<template>
  <div id="club-directorate" class="club-directorate flex flex-col app-page-wrapper absolute">
    <menu-component menu-type="club-directorate" :title="$t('club.directorate')">
      <app-icon
        v-tippy="{
          theme: 'WSM',
          content: $t('club.clubEmployeeDesc'),
          placement: 'left',
          maxWidth: '62rem',
        }"
        icon-name="info-70"
        class="modal-title-icon"
      />
    </menu-component>
    <section class="w-full h-full safe-area">
      <clubs-building-employees building-type="directorate" />
    </section>
  </div>
</template>

<script lang="ts">
import ClubsBuildingEmployees from '@/components/Club/ClubsBuildingEmployees.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ClubsDirectorate',
  components: {
    ClubsBuildingEmployees,
  },
})
</script>
